<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <quita-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import QuitaShowData from "./QuitaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "QuitaShow",
        components: {CrudShow, QuitaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.quita.showing',
            }
        },
    }
</script>

